import "./OurBrands.css";
import { useState } from "react";
import { FaSearch, FaArrowRight } from "react-icons/fa";

function OurBrands() {

const brands = [

{
id:1,
name:"CenturyPly",
category:"Plywood",
description:"India's leading plywood manufacturer offering premium quality plywood and laminates.",
image:"https://images.unsplash.com/photo-1484154218962-a197022b5858?w=900&auto=format&fit=crop"
},

{
id:2,
name:"Greenply",
category:"Plywood",
description:"Trusted brand for plywood, block boards and decorative veneers.",
image:"https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=900&auto=format&fit=crop"
},

{
id:3,
name:"Merino",
category:"Laminates",
description:"Premium laminates and decorative surface solutions.",
image:"https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=900&auto=format&fit=crop"
},

{
id:4,
name:"Action TESA",
category:"MDF",
description:"High quality MDF boards and panel products.",
image:"https://images.unsplash.com/photo-1460317442991-0ec209397118?w=900&auto=format&fit=crop"
},

{
id:5,
name:"Greenlam",
category:"Laminate",
description:"Decorative laminates for modern interiors.",
image:"https://images.unsplash.com/photo-1513694203232-719a280e022f?w=900&auto=format&fit=crop"
},

{
id:6,
name:"Pidilite",
category:"Adhesive",
description:"India's No.1 adhesive brand.",
image:"https://images.unsplash.com/photo-1494526585095-c41746248156?w=900&auto=format&fit=crop"
}

];

const [search,setSearch]=useState("");

const filteredBrands=brands.filter((item)=>

item.name.toLowerCase().includes(search.toLowerCase()) ||

item.category.toLowerCase().includes(search.toLowerCase())

);

return(

<>

<section className="brand-hero">

<div className="brand-overlay">

<h1>
Our Brands
</h1>

<p>

We Deal With India's Most Trusted Plywood,
Laminate, Hardware and Interior Brands.

</p>

<div className="brand-search">

<FaSearch/>

<input
type="text"
placeholder="Search Brand..."
value={search}
onChange={(e)=>setSearch(e.target.value)}
/>

</div>

</div>

</section>

<section className="brand-section">

<h2>
Featured Brands
</h2>

<div className="brand-grid">

{

filteredBrands.map((item)=>(

<div
className="brand-card"
key={item.id}
>

<div className="brand-image">

<img
src={item.image}
alt={item.name}
/>

</div>

<div className="brand-content">

<h3>
{item.name}
</h3>

<h4>
{item.category}
</h4>

<p>
{item.description}
</p>

<button>

Explore Products

<FaArrowRight/>

</button>

</div>

</div>

))

}

</div>

</section>

</>

);

}

export default OurBrands;